exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-lists-customers-show-last-invoice .modal-content{max-height:600px}#modal-lists-customers-show-last-invoice table{font-size:9pt}#modal-lists-customers-show-last-invoice table .thumbnail{width:40px;height:40px}", ""]);

// exports
